import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { Router } from '@angular/router';
import { Clipboard } from '@angular/cdk/clipboard';

import { ToastService } from '@web-frontend/shared/services/toast/toast.service';
import { finalize } from 'rxjs/operators';
import { CreateRecurrentPaymentsLinkService } from './services/create-recurrent-payments-link.service';

interface RecurrentPaymentLinkData {
  ticketId: string;
  products: { price: number; quantity: number; name: string }[];
  interval: 'week' | 'month' | 'year';
}

@Component({
  selector: 'roma-create-recurrent-payments-link',
  templateUrl: './create-recurrent-payments-link.component.html',
  styleUrls: ['./create-recurrent-payments-link.component.scss'],
})
export class CreateRecurrentPaymentsLinkComponent implements OnInit {
  public paymentLinkForm: FormGroup = new FormGroup({
    price: new FormControl(0, [Validators.required, Validators.min(0)]),
    quantity: new FormControl(1, [Validators.required, Validators.min(1)]),
    name: new FormControl('', [Validators.required, Validators.minLength(1)]),
    ticketId: new FormControl('', [
      Validators.required,
      Validators.minLength(1),
    ]),
    interval: new FormControl('day'),
  });

  paymentLink = '';
  isLoading = false;

  constructor(
    private router: Router,
    private createRecurrentPaymentsLink: CreateRecurrentPaymentsLinkService,
    private clipboard: Clipboard,
    private toastService: ToastService,
    private cdRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {}

  back() {
    this.router.navigateByUrl('/admin/payments');
  }

  private draw() {
    this.cdRef.detectChanges();
  }

  onSubmit() {
    if (this.paymentLinkForm.invalid) return;

    const payload: RecurrentPaymentLinkData = {
      ticketId: this.paymentLinkForm.value.ticketId,
      products: [
        {
          price: this.paymentLinkForm.value.price,
          name: this.paymentLinkForm.value.name,
          quantity: this.paymentLinkForm.value.quantity,
        },
      ],
      interval: this.paymentLinkForm.value.interval,
    };

    this.isLoading = true;
    this.createRecurrentPaymentsLink
      .generate(payload)
      .pipe(
        finalize(() => {
          this.isLoading = false;
          this.draw();
        })
      )
      .subscribe((res) => {
        if ('url' in res) {
          this.paymentLink = res['url'] as string;
        }
      });
  }

  shareLink() {
    this.clipboard.copy(this.paymentLink);
    this.toastService.show({
      text: 'activity.copyLink',
      type: 'success',
      msDuration: 4000,
      class: '',
    });
  }
}
